import { useEffect, useState } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import PublicNav from "@/components/PublicNav";
import PublicFooter from "@/components/PublicFooter";
import { ArrowRight, ArrowLeft } from "lucide-react";

export default function DesignDetailPage() {
  const { slug } = useParams();
  const [d, setD] = useState(null);
  const nav = useNavigate();

  useEffect(() => {
    api.get(`/public/designs/${slug}`).then((r) => setD(r.data)).catch(() => nav("/designs"));
  }, [slug, nav]);

  if (!d) return <div className="min-h-screen"><PublicNav/><div className="pt-32 px-6 text-muted-foreground">Loading…</div></div>;

  return (
    <div className="min-h-screen bg-background" data-testid="design-detail-page">
      <PublicNav/>

      <div className="pt-24 lg:pt-28">
        <div className="w-full aspect-[16/9] max-h-[720px] overflow-hidden bg-muted">
          <img src={d.hero_unsplash} alt={d.title} className="w-full h-full object-cover"/>
        </div>
      </div>

      <div className="max-w-6xl mx-auto px-6 lg:px-12 py-16 grid lg:grid-cols-[1fr,340px] gap-12">
        <div>
          <Link to="/designs" className="text-xs text-muted-foreground hover:text-foreground inline-flex items-center gap-1 mb-8">
            <ArrowLeft className="w-3 h-3" strokeWidth={1.5}/> All designs
          </Link>
          <div className="overline">Design Study · {d.style}</div>
          <h1 className="font-serif font-light mt-4" style={{ fontSize: "clamp(40px, 5vw, 60px)", lineHeight: 1.05 }}>{d.title}</h1>
          <p className="text-muted-foreground mt-6 leading-relaxed text-lg max-w-2xl">{d.description}</p>

          <div className="mt-10 border-t border-border pt-8">
            <div className="overline">Material Highlights</div>
            <ul className="mt-4 grid grid-cols-2 gap-2 text-sm">
              {d.material_highlights?.map((m) => <li key={m}>· {m}</li>)}
            </ul>
          </div>

          <div className="mt-10 border-t border-border pt-8">
            <div className="overline">Features</div>
            <ul className="mt-4 grid grid-cols-2 gap-2 text-sm">
              {d.features?.map((m) => <li key={m}>· {m}</li>)}
            </ul>
          </div>
        </div>

        <aside className="lg:sticky lg:top-24 self-start">
          <div className="luxe-card p-6">
            <div className="overline">Indicative Investment</div>
            <div className="font-serif text-3xl font-light mt-3">
              ${d.indicative_investment_min?.toLocaleString()}–${d.indicative_investment_max?.toLocaleString()}
            </div>
            <div className="text-xs text-muted-foreground mt-1">AUD, inc. GST — subject to final specification.</div>
            <Link to={`/enquiry?inspiration=${d.id}`} data-testid="btn-create-like-this" className="btn-accent w-full justify-center mt-6" style={{ padding: "14px 20px" }}>
              Create Something Like This <ArrowRight className="w-4 h-4" strokeWidth={1.5}/>
            </Link>
            <div className="text-[10px] text-muted-foreground mt-3 text-center">Reference kept on your enquiry</div>
          </div>
        </aside>
      </div>

      <PublicFooter/>
    </div>
  );
}
